import { render, staticRenderFns } from "./InformacoesPessoais.vue?vue&type=template&id=1ab249c6"
import script from "./InformacoesPessoais.vue?vue&type=script&lang=js"
export * from "./InformacoesPessoais.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports